import { useLocation } from '@tanstack/react-router';
import { Button, LoaderSpinner } from '@thetreep/travel-ui';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { useCurrentUser } from '../hooks/useCurrentUser';
import { LOGIN_PATH } from '../login';

// Holds the page until the session is confirmed. Without a session, GetMe fails with
// Unauthenticated and the global API error handler sends the browser to the login page.
export const AuthGate = ({ children }: { children: ReactNode }) => {
	const { t } = useTranslation();
	const { pathname } = useLocation();
	const { user, isError, refetch } = useCurrentUser();

	if (pathname === LOGIN_PATH || user) {
		return children;
	}

	if (isError) {
		return (
			<div className="flex min-h-screen flex-col items-center justify-center gap-4">
				<p className="typography-body-m">{t('auth.gate.error')}</p>
				<Button variant="primary" size="m" onPress={() => void refetch()}>
					{t('auth.gate.retry')}
				</Button>
			</div>
		);
	}

	return (
		<div className="flex min-h-screen items-center justify-center">
			<LoaderSpinner />
		</div>
	);
};
